import { render, staticRenderFns } from "./paba-auth.vue?vue&type=template&id=36bb61e6&scoped=true&lang=pug"
import script from "./paba-auth.vue?vue&type=script&lang=js"
export * from "./paba-auth.vue?vue&type=script&lang=js"
import style0 from "./paba-auth.vue?vue&type=style&index=0&id=36bb61e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bb61e6",
  null
  
)

export default component.exports